import { render } from "./VtoApp.vue?vue&type=template&id=e4f8839a"
import script from "./VtoApp.vue?vue&type=script&lang=js"
export * from "./VtoApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__